import styled from 'styled-components'
import { Box, Flex } from 'rebass'
import {
  margin,
  marginTop,
  marginBottom,
  marginRight,
  width,
  height,
  display,
  overflow,
} from 'styled-system'
import { fill } from 'styles/sharedStyle'
import { getBGColor, getSpacing, getMediaQuerie } from 'utils/themeUtils'

export const FooterContainer = styled(Box).attrs({
  role: 'contentinfo',
})`
  background-color: ${getBGColor()};
`

export const FooterFlex = styled(Flex)`
  ${overflow}
`

export const SVGWrapper = styled.span`
  display: inline-block;
  ${margin}
  ${marginTop}
  ${marginBottom}
  ${marginRight}
  ${height}
  ${width}
  ${display}
  * {
    ${fill}
  }
`

export const LogoWrapper = styled(SVGWrapper)`
  html[dir='ltr'] & {
    margin-right: ${getSpacing(8)};
  }

  html[dir='rtl'] & {
    margin-left: ${getSpacing(8)};
  }

  ${getMediaQuerie('small')} {
    html[dir='ltr'] & {
      margin-right: 0;
    }

    html[dir='rtl'] & {
      margin-left: 0;
    }
  }

  ${getMediaQuerie('medium')} {
    html[dir='ltr'] & {
      margin-right: ${getSpacing(4)};
    }

    html[dir='rtl'] & {
      margin-left: ${getSpacing(4)};
    }
  }
`
